import React from 'react';
import { 
  Search, 
  Settings, 
  Gauge, 
  TrendingUp, 
  BarChart3,
  CheckCircle2,
  ArrowRight
} from 'lucide-react';
import { Button } from '@/components/ui/button';

const seoServices = [
  { icon: Search, title: 'Algorithmic Optimization', description: 'Deep content engineering and meta structuring' },
  { icon: Settings, title: 'Technical Architecture', description: 'Immaculate DOM structure and crawl dynamics' },
  { icon: Gauge, title: 'Edge Delivery', description: 'Sub-second latency across global CDNs' },
  { icon: TrendingUp, title: 'Conversion Science', description: 'Data-backed psychological funnels' },
  { icon: BarChart3, title: 'Telemetry & Analytics', description: 'Real-time granular user tracking' },
];

export default function SEOSection() {
  return (
    <section id="seo" className="py-24 md:py-32 bg-zinc-950 relative overflow-hidden border-t border-white/5">
      {/* Background elements */}
      <div className="absolute top-1/4 right-0 w-[600px] h-[600px] bg-[radial-gradient(ellipse_at_center,rgba(37,99,235,0.05)_0%,transparent_70%)] pointer-events-none" />
      <div className="absolute bottom-0 left-[-10%] w-[500px] h-[500px] bg-[radial-gradient(ellipse_at_center,hsl(var(--primary)/0.05)_0%,transparent_70%)] pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div
           
           
           
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-white/10 bg-white/5 mb-6">
              <span className="text-sm font-semibold text-zinc-300 uppercase tracking-widest">
                Growth Infrastructure
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white mt-4 mb-6 tracking-tight">
              Dominating search, <br />
              <span className="text-gradient">capturing intent.</span>
            </h2>
            
            <p className="text-lg text-zinc-400 mb-10 max-w-lg leading-relaxed font-light">
              Traffic is irrelevant without conversion. We engineer SEO strategies formulated not just to rank, but to monopolize your high-value digital real estate.
            </p>

            <Button 
              size="lg"
              className="bg-white text-zinc-950 hover:bg-zinc-200 h-14 px-8 font-bold rounded-xl text-lg hover:shadow-[0_0_20px_rgba(255,255,255,0.15)] transition-all group"
            >
              Initiate System Audit
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>

          <div
           
           
           
            className="space-y-4"
          >
            {seoServices.map((service, index) => (
              <div
                key={service.title}
               
               
               
               
                className="flex items-start gap-5 p-6 rounded-3xl bg-zinc-900/40 backdrop-blur-md border border-white/5 hover:border-white/20 hover:bg-white/5 transition-all duration-300 group hover:-translate-y-1"
              >
                <div className="w-14 h-14 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center shrink-0 group-hover:bg-primary/20 group-hover:border-primary/30 transition-all duration-300">
                  <service.icon className="w-6 h-6 text-zinc-400 group-hover:text-primary transition-colors" />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-white mb-1 tracking-tight">{service.title}</h3>
                  <p className="text-zinc-500 text-sm leading-relaxed">{service.description}</p>
                </div>
                <CheckCircle2 className="w-6 h-6 text-primary/50 shrink-0 group-hover:text-primary transition-colors mt-2" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}